// FERRAMENTA DE DIAGNÓSTICO TEMPORÁRIA — remover junto com o modal e o
// endpoint `gateway_medical_prescriptions/diagnostics/*` do backend.
//
// Reproduz a tela de prescrição COMO outro médico, para investigar o relato
// de "Houve um problema ao tentar carregar a página" sem depender de o médico
// afetado estar disponível. O menu que abre isto só aparece para esta conta —
// mas quem realmente barra é o backend (403 para qualquer outra). Esconder o
// menu não é controle de acesso.
export const DIAGNOSTIC_ACCOUNT_EMAIL = "coras17483@murkstar.com";

export function isDiagnosticAccount(user) {
  return !!user && user.email === DIAGNOSTIC_ACCOUNT_EMAIL;
}

// A aba de prescrição é aberta com `window.open`, e o token do médico-alvo
// precisa chegar até ela. O navegador clona o sessionStorage do abridor para a
// aba nova no momento do open (mesma exceção da spec que já sustenta a herança
// de sessão — ver docs/design/flow-d05-receita.md), então escrevemos a chave
// aqui, abrimos, e apagamos do abridor: a cópia clonada sobrevive só na aba
// nova, que a consome e limpa.
const DIAGNOSTIC_TOKEN_KEY = "memed-diagnostic-token";

export function stashDiagnosticToken(payload, storage = window.sessionStorage) {
  try {
    storage.setItem(DIAGNOSTIC_TOKEN_KEY, JSON.stringify(payload));
  } catch (error) {
    // sessionStorage indisponível (aba anônima com site data bloqueado): o
    // fluxo de diagnóstico simplesmente não abre, e o real segue intacto.
  }
}

export function clearOpenerDiagnosticToken(storage = window.sessionStorage) {
  try {
    storage.removeItem(DIAGNOSTIC_TOKEN_KEY);
  } catch (error) {
    // idem
  }
}

// Lida pela aba nova. Devolve o token e o esquece: um diagnóstico não pode
// deixar o token de terceiro parado no storage depois de usado.
export function takeDiagnosticToken(storage = window.sessionStorage) {
  let raw = null;
  try {
    raw = storage.getItem(DIAGNOSTIC_TOKEN_KEY);
    storage.removeItem(DIAGNOSTIC_TOKEN_KEY);
  } catch (error) {
    return null;
  }
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}
